import { render, staticRenderFns } from "./BoxImage.vue?vue&type=template&id=57c0bcc3&scoped=true"
import script from "./BoxImage.vue?vue&type=script&lang=js"
export * from "./BoxImage.vue?vue&type=script&lang=js"
import style0 from "./BoxImage.vue?vue&type=style&index=0&id=57c0bcc3&prod&scoped=true&lang=css"
import style1 from "./BoxImage.vue?vue&type=style&index=1&id=57c0bcc3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c0bcc3",
  null
  
)

export default component.exports